import { useEffect } from 'react';

import { HookForm, Password } from '@dec/shared';
import env from 'env';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useParams } from 'react-router-dom';

import validations from '../../components/recoverPassword.validations';
import { type RecoverPasswordState } from '../../models/recoverPassword.model';

import { useRecoverPassword } from './useRecoverPassword';

interface Props {
  changePassword?: boolean;
}

export const RecoverPassword = ({ changePassword }: Props) => {
  const { userType } = useParams();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const { t, i18n } = useTranslation();
  const { loading, submitForm } = useRecoverPassword();

  useEffect(() => {
    const locale = query.get('locale');
    if (locale) {
      i18n.changeLanguage(locale);
    }
  }, []);

  const onSubmit = (values: RecoverPasswordState) => {
    submitForm({
      userId: query.get('userId') ?? '',
      code: query.get('code') ?? '',
      newPassword: values.newPassword
    });
  };

  const cancel = () => {
    window.location.href = (changePassword || env.appUrl) as string;
  };

  return (
    <div className="container h-100 login">
      <div className="row align-items-center h-100">
        <div className="col-12 col-sm-10 col-md-7 col-lg-5 col-xl-4 col-xxl-3 mx-auto">
          <Card className="px-0 px-sm-4 pt-2 pb-5 login-card">
            <Card.Body>
              <Row className="mt-3 mb-2 px-5 px-sm-5">
                <Col className="d-block">
                  <div className="img-fluid mx-auto mb-2 loginLogo"></div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <h1>
                    {changePassword
                      ? t('security-password-recovery.label.changePassword')
                      : t('security-password-recovery.label.title')}
                  </h1>
                </Col>
              </Row>
              <HookForm onSubmit={onSubmit} validations={validations}>
                <Row>
                  <Col>
                    <Password
                      label={t('security-password-recovery.label.newPassword')}
                      name="newPassword"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Password
                      label={t('security-password-recovery.label.repeatPassword')}
                      name="repeatPassword"
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col>
                    <Button type="submit" variant="primary" disabled={loading}>
                      {t('common.label.send')}
                    </Button>{' '}
                    <div className="text-center mt-3">
                      <Link to="#" onClick={cancel}>
                        {t('common.label.cancel')}
                      </Link>
                    </div>
                  </Col>
                </Row>
              </HookForm>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
};
